import module from 'module';
import StatusBasedService from "./statusBasedService";

module.factory('workingDayService', (statusService) =>
  new StatusBasedService({
    property: 'workingDay',
    statusService: statusService
  }));